import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_AUTHORIZATION_STATUS' as const;
export { ExportStatus as Status };
